import { getGlossarysByPattern, getLikelyValuesByName } from "./api";
export function AutoComplete(input, label) {
  return GetGlossaryMatches(input, label);
}

async function GetGlossaryMatches(input, label) {
  let GlossaryItems = [];

  if (input?.length < 2 || !input) {
    GlossaryItems = await getLikelyValuesByName(label);

    return GlossaryItems;
  }
  const payload = { collection: "glossary", pattern: input };
  const GlossaryMatchesObjects = await getGlossarysByPattern(payload);

  for (let match of GlossaryMatchesObjects) {
    GlossaryItems.push(match.name);
  }
  return GlossaryItems;
}
